import { htmlDecode } from '../../../helpers/dom'
import { UserLanguage } from '../../account/types/User'
import { TrackingEvent } from '../types/TrackingEvents'

const MAX_DESCRIPTION_LENGTH = 300

/**
 * First non-empty paragraph of an event's analyst review comment, stripped of
 * markup and truncated — the short description shown in the calendar/evolution
 * hover popups (`LiveEventInfoTooltipContent`). Extracted from
 * `LiveEventEvolutionTimeline` so other surfaces (e.g. the Market Analytics
 * games drill-down) can render the exact same popup content.
 */
export const getTrackingEventDescriptionSnippet = (trackingEvent: TrackingEvent | undefined, userLanguage: UserLanguage): string | null | undefined => {
  if (!trackingEvent) {
    return null
  }

  const descriptionHTML = trackingEvent.comment?.content?.comment?.[userLanguage]
    ? trackingEvent.comment?.content?.comment?.[userLanguage]
    : trackingEvent.comment?.content?.comment?.['en']

  if (!descriptionHTML) {
    return undefined
  }

  const paragraphs = descriptionHTML.split('</p>')

  // find the first paragraph with content
  const paragraph = paragraphs.find((candidate: string) => {
    return !!candidate.replace(/<\/?[^>]+(>|$)/g, '')
  })

  const strippedParagraph = paragraph?.replace(/<\/?[^>]+(>|$)/g, '') || ''
  const decodedParagraph = htmlDecode(strippedParagraph)

  if (decodedParagraph && decodedParagraph.length > MAX_DESCRIPTION_LENGTH) {
    return decodedParagraph.substring(0, MAX_DESCRIPTION_LENGTH) + '...'
  }

  return decodedParagraph
}
